export const filterOptions = [
  { label: 'CPF', value: 'cpf' },
  { label: 'Nome do Cliente', value: 'nomecliente' },
  { label: 'Data de Inclusão', value: 'dataInclusao' },
  { label: 'Usuário Exclusor', value: 'usuario' }
]
